import { render, staticRenderFns } from "./VpiCalculationForm.vue?vue&type=template&id=48f370b0&scoped=true&"
import script from "./VpiCalculationForm.vue?vue&type=script&lang=ts&"
export * from "./VpiCalculationForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f370b0",
  null
  
)

export default component.exports